<template>
    <div class="position-box">
        <div class="cotainer">
          <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('footer.my')}}</div>
          </div>
           <div class="head-box">
               <ul class="item1-box" v-if="lang == 'ar'">
                   <li><img class="icon" src="@/assets/user/shezhi2.png" @click="set" alt=""></li>
                   <li class="item1-lt">
                       <div>
                         <div class="text">{{userName | mdName}}</div>
                         <div class="id">ID: {{userID}}</div>
                       </div>
                       <img class="img" :src="touxiang3" alt="">
                   </li>
               </ul>
               <ul class="item1-box" v-else>
                   <li class="item1-lt">
                       <img class="img" :src="touxiang3" alt="">
                       <div>
                         <div class="text">{{userName | mdName}}</div>
                         <div class="id">ID: {{userID}}</div>
                       </div>
                   </li>
                   <li><img class="icon" src="@/assets/user/shezhi2.png" @click="set" alt=""></li>
               </ul>
               <div class="assets-wrap" @click.stop="goAssets">
                   <img class="user-bg" src="@/assets/user/user-bg.png" alt="">
                   <div class="assets-box" v-if="lang == 'ar'">
                      <img class="arrow" src="@/assets/theme/icon_back.png" alt="">
                       <div class="assets-lt">
                          <div class="assets-tips">
                              <img class="icon" v-show="isPwd" @click.stop="change" src="@/assets/user/biyan.png" alt="">
                              <img class="icon" v-show="!isPwd" @click.stop="change" src="@/assets/user/zhenyan.png" alt="">
                              <div class="text">{{$t('my.wdzc1')}} (USDT)</div>
                          </div>
                          <div class="assets"><input type="text" class="money" ref="input" v-model="money"></div>
                        </div>
                   </div>
                   <div class="assets-box" v-else>
                       <div class="assets-lt">
                            <div class="assets-tips">
                                <div class="text">{{$t('my.wdzc1')}} (USDT)</div>
                                <img class="icon" v-show="isPwd" @click.stop="change" src="@/assets/user/biyan.png" alt="">
                                <img class="icon" v-show="!isPwd" @click.stop="change" src="@/assets/user/zhenyan.png" alt="">
                            </div>
                            <div class="assets"><input type="text" class="money" ref="input" v-model="money"></div>
                        </div>
                        <img class="arrow" src="@/assets/theme/jiantou_white.png" alt="">
                   </div>
               </div>
               <ul class="tab-box">
                   <li class="tab" @click="jump('deposit')">
                       <img class="icon" v-if="theme" src="@/assets/user/chongbi.png" alt="">
                       <img class="icon" v-else src="@/assets/user/chongbi.png" alt="">
                       <div class="text">{{$t('assets.cmoney')}}</div>
                   </li>
                   <li class="tab"  @click="jump('withdraw')">
                      <img class="icon" v-if="theme" src="@/assets/user/tibi.png" alt="">
                      <img class="icon" v-else src="@/assets/user/tibi.png" alt="">
                      <div class="text">{{$t('assets.tmoney')}}</div>
                   </li>
                   <router-link class="tab" tag="li" to="/accountRecords">
                      <img class="icon" v-if="theme" src="@/assets/user/zhanghu.png" alt="">
                      <img class="icon" v-else src="@/assets/user/zhanghu.png" alt="">
                      <div class="text">{{$t('my.ar')}}</div>
                   </router-link>
                   <!-- <router-link class="tab" tag="li" to="/quicklyBuyCoins">
                      <img class="icon" v-if="theme" src="@/assets/user/kuaijie.png" alt="">
                      <img class="icon" v-else src="@/assets/user/kuaijie.png" alt="">
                      <div class="text">{{$t('kjmb.title')}}</div>
                   </router-link> -->
               </ul>
           </div>
            <div class="line"></div>
            <ul class="ul-box" v-if="lang == 'ar'">
                <li class="li" v-show="isSmrz == 1" @click="base_auth_status != 2 && link(0)">
                  <template v-if="base_auth_status != 2">
                      <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                      <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    </template>
                    <img class="arrow icon" v-else="base_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                  <div class="li-lt">
                      <div class="text">{{$t('my.sfyz')}}</div>
                      <img class="icon" src="@/assets/user/senior.png" alt="">
                  </div>
                  <!-- <div class="status">未认证</div> -->
                </li>
                <li class="li" v-show="isCjrz == 1" @click="name_auth_status != 2 && link(1)">
                  <template v-if="name_auth_status != 2">
                      <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                      <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    </template>
                    <img class="arrow icon" v-else-if="name_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <div class="li-lt">
                      <div class="text">{{$t('my.pc')}}</div>
                      <img class="icon" src="@/assets/user/senior.png" alt="">
                    </div>
                    <!-- <div class="status">未认证</div> -->
                </li>
                <li class="li" v-show="isGjrz == 1" @click="base_auth_status != 2 && link(2)">
                  <template v-if="base_auth_status != 2">
                      <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                      <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    </template>
                    <img class="arrow icon" v-else-if="base_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <div class="li-lt">
                      <div class="text">{{$t('gjrz.title')}}</div>
                      <img class="icon" src="@/assets/user/senior.png" alt="">
                    </div>
                    <!-- <div class="status">未认证</div> -->
                </li>
                <li class="li" tag="li" v-show="isDzrz == 1" @click="link(3) && address_auth_status != 2">
                    <template v-if="address_auth_status != 2">
                      <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                      <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    </template>
                    <img class="arrow icon" v-else-if="address_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <div class="li-lt">
                      <div class="text">{{$t('dzrz.title')}}</div>
                      <img class="icon" src="@/assets/user/dizhi.png" alt="">
                    </div>
                </li>
            </ul>
            <ul class="ul-box" v-else>
                <li class="li" v-show="isSmrz == 1" @click="base_auth_status != 2 && link(0)">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/senior.png" alt="">
                        <div class="text">{{$t('my.sfyz')}}</div>
                    </div>
                    <!-- <div class="status">未认证</div> -->
                    <img class="arrow icon" v-if="base_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <template v-else>
                      <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                      <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                    </template>
                </li>
                <li class="li" v-show="isCjrz == 1" @click="name_auth_status != 2 && link(1)">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/senior.png" alt="">
                        <div class="text">{{$t('my.pc')}}</div>
                    </div>
                    <!-- <div class="status">未认证</div> -->
                    <img class="arrow icon" v-if="name_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <template v-else>
                      <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                      <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                    </template>
                </li>
                <li class="li" v-show="isGjrz == 1" @click="base_auth_status != 2 && link(2)">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/senior.png" alt="">
                        <div class="text">{{$t('gjrz.title')}}</div>
                    </div>
                    <!-- <div class="status">未认证</div> -->
                    <img class="arrow icon" v-if="base_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <template v-else>
                      <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                      <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                    </template>
                </li>
                <li class="li" tag="li" v-show="isDzrz == 1" @click="link(3) && address_auth_status != 2">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/dizhi.png" alt="">
                        <div class="text">{{$t('dzrz.title')}}</div>
                    </div>
                    <img class="arrow icon" v-if="address_auth_status == 2" src="@/assets/btn-tg.png" alt="">
                    <template v-else>
                      <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                      <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                    </template>
                </li>
            </ul>
            <div class="line"></div>
            <ul class="ul-box" v-if="lang == 'ar'">
                <router-link class="li" tag="li" to="/credit" v-show="isCredit == 1">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="li-lt">
                      <div class="text">{{$t('xyf.title')}}</div>
                      <img class="icon" src="@/assets/user/xinyufen.png" alt="">
                    </div>
                </router-link>
                <li class="li" v-show="service_link" @click="service">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="li-lt">
                      <div class="text">{{$t('my.zxkf')}}</div>
                      <img class="icon" src="@/assets/user/kefu.png" alt="">
                    </div>
                </li>
                <router-link class="li" tag="li" to="/help">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="li-lt">
                      <div class="text">{{$t('my.hc')}}</div>
                      <img class="icon" src="@/assets/user/guanyu.png" alt="">
                    </div>
                </router-link>
            </ul>
            <ul class="ul-box" v-else>
                <router-link class="li" tag="li" to="/credit" v-show="isCredit == 1">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/xinyufen.png" alt="">
                        <div class="text">{{$t('xyf.title')}}</div>
                    </div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <li class="li" v-show="service_link" @click="service">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/kefu.png" alt="">
                        <div class="text">{{$t('my.zxkf')}}</div>
                    </div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </li>
                <router-link class="li" tag="li" to="/help">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/guanyu.png" alt="">
                        <div class="text">{{$t('my.hc')}}</div>
                    </div>
                     <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link>
                <!-- <router-link class="li" tag="li" to="/set">
                    <div class="li-lt">
                        <img class="icon" src="@/assets/user/shezhi.png" alt="">
                        <div class="text">{{$t('my.as')}}</div>
                    </div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </router-link> -->
            </ul>
        </div>
        <!-- <nav-bar :navName="'user'"></nav-bar> -->
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'user',
    data () {
        return {
            theme: false,
            userName: '',
            userID: '',
            money: '',
            isSmrz: 0,
            isCjrz: 0,
            isGjrz: 0,
            isDzrz: 0,
            isCredit: 0,
            name_auth_status: 0,
            base_auth_status: 0,
            address_auth_status: 0,
            service_link: '',
            isPwd: false,
            lang: 'en',
            isMn: false
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.isPwd = JSON.parse(localStorage.getItem('isPwd'));
      this.lang = localStorage.getItem('language') || 'en';
      this.isMn = JSON.parse(localStorage.getItem('isMn'));
    },
    mounted() {
        if(this.isPwd){
            this.$refs.input.type = "password";
        }else{
            this.$refs.input.type = "text"
        }
        this.getInfo();
        this.getAsset();
        this.getCenterLevel();
        this.getParams();
        this.getRenzheng();
    },
    methods: {
       back(){
           this.$router.push('/index')
       },
       set(){
           this.$router.push('/set')
       },
       goAssets(){
           this.$router.push('/myAssets')
       },
       getInfo(){
           this.$ajax.get('/web/info',{}).then((res) => {
                let resData = res.data.data;
                this.userName = resData.name;
                this.userID = resData.id;
                localStorage.setItem('username',resData.name);
            }).catch(function(err){
                console.log(err)
            })
       },
       getAsset(){
           this.$ajax.get('/web/getAsset2',{}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  // this.$toast.center(res.data.message);
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                this.money = (Number(resData.totalMoney)).toFixed(4);
            }).catch(function(err){
                console.log(err)
            })
       },
       getCenterLevel(){
           this.$ajax.get('/web/getCenterLevel',{level:1}).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 1000){
                  // this.$toast.center(res.data.message);
                  setTimeout(()=>{
                    this.$router.push('/login');
                  },1000)
                  return false
                }
                this.name_auth_status = resData.name_auth_status;
                this.base_auth_status = resData.base_auth_status;
                this.address_auth_status = resData.address_auth_status;
            }).catch(function(err){
                console.log(err)
            })
       },
       getParams(){
           this.$ajax.get('/web/getParam',{token: 1}).then((res) => {
                let resData = res.data.data;
                this.service_link = resData.filter((item) =>{
                    if(item.key == 'online_service'){
                        return item
                    }
                })[0].value;
            }).catch(function(err){
                console.log(err)
            })
       },
       getRenzheng(){
            this.$ajax.get('/web/has_renzheng',{}).then((res) => {
                let resData = res.data.data;
                this.isSmrz = resData.level;
                this.isCjrz = resData.level1;
                this.isGjrz = resData.level2;
                this.isDzrz = resData.level3;
                this.isCredit = resData.credit;
                localStorage.setItem("signature",resData.signature);
            }).catch(function(err){
                console.log(err)
            })
       },
       change(){
            this.isPwd = !this.isPwd;
            localStorage.setItem('isPwd',this.isPwd);
            if (this.isPwd) {
                this.$refs.input.type = "password"
            }else{
                this.$refs.input.type = "text"
            }
        },
        jump(url){
          if(url == "deposit"){
            if(this.isMn){
              this.$toast.center(this.$t('langNew.qdlzszh'));
              return;
            }
            this.$router.push({ path: '/deposit', query: { type: 1,url: url } })
          }else{
            this.$router.push({ path: '/selectCurrency', query: { type: 1,url: url } })
          }
        },
        link(id){
            if(id == 0){
                this.$router.push('/authentication')
            }else if(id == 1){
                this.$router.push('/primaryCertification')
            }else if(id == 2){
                this.$router.push('/advancedCertification')
            }else{
                this.$router.push('/addressAuth')
            }
        },
        service(){
          if(!this.service_link) return;
          var kfUrl;
          var userId = localStorage.getItem('userId');
          if(userId){
            var userInfo = {
              "uid":userId,
              "name":userId
            }
            var userUrl = encodeURIComponent(JSON.stringify(userInfo));
            kfUrl = this.service_link + "&userInfo=" + userUrl;
          }else{
            kfUrl = this.service_link;
          }
          this.$router.push({ path: '/service', query: { url: kfUrl } })
        },
    },
    components:{
        navBar,
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .cotainer{
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .head-box{
        padding: 1.6rem .56rem .6rem;
        background: #fff;
    }
    .head-box .item1-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .head-box .item1-box .item1-lt{
        display: flex;
        align-items: center;
    }
    .head-box .item1-box .img{
        width: 1.12rem;
        height: 1.12rem;
    }
    .head-box .item1-box .text{
        padding: 0 .3rem;
        color: #1d223a;
        font-size: .6rem;
    }
    .head-box .item1-box .id{
        padding: .2rem .3rem 0;
        color: #1d223a;
        font-size: .42rem;
    }
    .head-box .item1-box .icon{
        width: .8rem;
    }
    .assets-wrap{
        position: relative;
        height: 2.68rem;
        margin: .46rem 0 .6rem;
    }
    .assets-wrap .user-bg{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 2.68rem;
    }
    .assets-wrap .assets-box{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 2.68rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .6rem .56rem .7rem .6rem;
        box-sizing: border-box;
    }
    .assets-wrap .assets-box .assets-tips{
        display: flex;
        align-items: center;
    }
    .assets-wrap .assets-box .assets-tips .text{
        padding-right: .3rem;
        color: #fff;
        font-size: .4rem;
    }
    .assets-wrap .assets-box .assets-tips .icon{
        width: .6rem;
        /* height: .36rem; */
    }
    .assets-wrap .assets-box .assets{
        padding-top: .3rem;
        color: #fff;
        font-size: .6rem;
    }
    .assets-wrap .assets-box .assets .money{
        color: #fff;
    }
    .assets-wrap .assets-box .arrow{
        width: .2rem;
    }
    .tab-box{
        display: flex;
        justify-content: space-around;
        align-items: stretch;
        text-align: center;
    }
    .tab-box .tab{
      width: 33%;
    }
    .tab-box .tab .icon{
        width: .88rem;
    }
    .tab-box .tab .text{
        padding-top: .3rem;
        color: #838996;
        font-size: .38rem;
    }
    .ul-box .li{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .7rem .6rem .35rem .6rem;
        background: #fff;
    }
    .ul-box .li .li-lt{
        display: flex;
        align-items: center;
    }
    .ul-box .li .li-lt .icon{
        width: .8rem;
        height: .8rem;
    }
    .ul-box .li .li-lt .text{
        padding: 0 .24rem;
        color: #838996;
        font-size: .48rem;
    }
    .ul-box .li .arrow{
        width: .18rem;
    }
    .ul-box .li .arrow.icon{
        width: .4rem;
    }
     .ul-box .li .status{
         position: absolute;
         right: 1.1rem;
         color: #838996;
         font-size: .34rem;
     }
</style>



// WEBPACK FOOTER //
// src/pages/user.vue